export default __webpack_public_path__ + "static/media/phones.61d18632.jpg";